import {TIMESHEET, USER_TIMESHEET, CLOCK_OUT_REASONS} from './../actions/ActionTypes';
import InitialState from './InitialState';

const DailyAttendanceReducer = (state = InitialState.dailyAttendance, action) => {
    switch (action.type) {
        case TIMESHEET: {
            let data = Object.assign({}, state);

            data.timesheet =  action.timesheet;
            return data;
        }

        case USER_TIMESHEET: {
            let data = Object.assign({}, state);

            data.userTimesheet =  action.timesheet;
            return data;
        }

        case CLOCK_OUT_REASONS: {
            let data = Object.assign({}, state);

            data.reasons =  action.reasons;
            return data;
        }

        default:
            return state;
    }
};

export default DailyAttendanceReducer;



// WEBPACK FOOTER //
// ./src/reducers/DailyAttendanceReducer.js